var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container", staticStyle: { background: "#f4f5f7" } },
    [
      _c("BjSteps", {
        attrs: {
          active: "3",
          title: _vm.$t("route.BusinessProfitCalculator"),
          defaultOptions: [
            _vm.$t("toolsProfit.CustomerDetails"),
            _vm.$t("toolsProfit.ChargeItems"),
            _vm.$t("toolsProfit.calculate"),
          ],
        },
      }),
      _c("div", { staticClass: "flex flex-spacebetween" }, [
        _c(
          "div",
          { staticClass: "profit-left" },
          [
            _c(
              "BjDivider",
              [
                _vm._v(_vm._s(_vm.$t("toolsProfit.CustomerDetails")) + " "),
                _c(
                  "template",
                  { slot: "right" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.calculate },
                      },
                      [_vm._v(_vm._s(_vm.$t("toolsProfit.calculate")))]
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "form",
                attrs: {
                  "label-width": "140px",
                  model: _vm.form,
                  rules: _vm.rules,
                  "label-position": "left",
                },
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("billingPage.CustomerName"),
                      prop: "customerName",
                    },
                  },
                  [
                    _c("BjInput", {
                      staticStyle: { width: "250px" },
                      attrs: {
                        maxlength: _vm.MAX_LENGTH.NORMAL,
                        placeholder: _vm.$t("inputText"),
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.customerName,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "customerName", $$v)
                        },
                        expression: "form.customerName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("toolsProfit.DataModel"),
                      prop: "dataModel",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { width: "250px" } },
                      [
                        _c("BjSelectLov", {
                          attrs: { "option-list": _vm.dataModelList },
                          model: {
                            value: _vm.form.dataModel,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "dataModel", $$v)
                            },
                            expression: "form.dataModel",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "AccountManagementAdd.customerInfo.CustomerType"
                      ),
                      prop: "customerType",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { width: "250px" } },
                      [
                        _c(
                          "BjInput",
                          {
                            attrs: {
                              disabled: true,
                              placeholder: _vm.$t("inputText"),
                            },
                            model: {
                              value: _vm.customerText,
                              callback: function ($$v) {
                                _vm.customerText = $$v
                              },
                              expression: "customerText",
                            },
                          },
                          [
                            _c(
                              "template",
                              { slot: "append" },
                              [
                                _c(
                                  "el-button",
                                  { on: { click: _vm.openCustomerType } },
                                  [_vm._v(_vm._s(_vm.$t("chooseText")))]
                                ),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("toolsProfit.Storage"),
                      prop: "storage",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-align" },
                      [
                        _c("BjInputMoney", {
                          staticStyle: { width: "250px" },
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.NORMAL,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.storage,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "storage", $$v)
                            },
                            expression: "form.storage",
                          },
                        }),
                        _c("span", { staticStyle: { "margin-left": "8px" } }, [
                          _vm._v(_vm._s(_vm.selectObj.storageType)),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("toolsProfit.PostageMargin"),
                      prop: "postageMargin",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-align" },
                      [
                        _c(
                          "el-input",
                          {
                            staticStyle: { width: "250px" },
                            attrs: {
                              controls: false,
                              placeholder: _vm.$t("inputText"),
                              onkeyup:
                                "this.value = this.value.replace(/[^\\d.-]/g,'');",
                            },
                            model: {
                              value: _vm.form.postageMargin,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "postageMargin", $$v)
                              },
                              expression: "form.postageMargin",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("%")])],
                          2
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("toolsProfit.WeeklyOrder"),
                      prop: "weeklyOrder",
                    },
                  },
                  [
                    _c("BjInputMoney", {
                      staticStyle: { width: "250px" },
                      attrs: {
                        maxlength: _vm.MAX_LENGTH.NORMAL,
                        placeholder: _vm.$t("inputText"),
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.weeklyOrder,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "weeklyOrder", $$v)
                        },
                        expression: "form.weeklyOrder",
                      },
                    }),
                  ],
                  1
                ),
                _vm.form.dataModel == 2
                  ? _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("toolsProfit.timePeriod"),
                          prop: "timePeriodFrom",
                        },
                      },
                      [
                        _c("BjDateRangePicker", {
                          staticStyle: { width: "250px" },
                          attrs: {
                            "picker-options": _vm.pickerOptions,
                            placeholder: _vm.$t("toolsProfit.timePeriod"),
                          },
                          model: {
                            value: _vm.dataTime,
                            callback: function ($$v) {
                              _vm.dataTime = $$v
                            },
                            expression: "dataTime",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "profit-right" },
          [
            _c("BjDivider", [
              _vm._v(_vm._s(_vm.$t("toolsProfit.ProfitComparison"))),
            ]),
            _c(
              "el-table",
              { attrs: { data: _vm.calculateTable, stripe: "", border: "" } },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "index",
                    label: _vm.$t("InternalOrderList.number"),
                    align: "center",
                    width: "60",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "comparisonItem",
                    label: _vm.$t("toolsProfit.ComparisonItem"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "sampleCompany",
                    label: _vm.$t("toolsProfit.SampleCompany"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "potentialCustomer",
                    label: _vm.$t("toolsProfit.PotentialCustomer"),
                    align: "center",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "profit-bottom" },
        [
          _c(
            "BjDivider",
            [
              _vm._v(_vm._s(_vm.$t("toolsProfit.ChargeItems")) + " "),
              _c(
                "template",
                { slot: "right" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: _vm.tableData[0] && !_vm.tableData[0].group,
                      },
                      on: { click: _vm.downLoad },
                    },
                    [_vm._v(_vm._s(_vm.$t("downloadText")))]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _vm._l(_vm.tableData, function (item, index) {
            return _c(
              "div",
              { key: index },
              [
                _c(
                  "el-table",
                  { attrs: { data: item.chargeItems, stripe: "", border: "" } },
                  [
                    _c(
                      "el-table-column",
                      { attrs: { label: item.group, align: "center" } },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "id",
                            label: _vm.$t("InternalOrderList.number"),
                            align: "center",
                            width: "60",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "chargeItem",
                            label: _vm.$t("billingPage.ChargeItem"),
                            align: "center",
                            width: "445",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "quantity",
                            label: _vm.$t("billingPage.quantity"),
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "standardPrice",
                            label: _vm.$t("billingPage.standardPrice"),
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      "$" + _vm._s(scope.row.standardPrice)
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "cost",
                            label: _vm.$t("billingPage.Cost"),
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [_vm._v("$" + _vm._s(scope.row.cost))]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "slendierPrice",
                            label:
                              (_vm.selectObj.sampleCompany
                                ? _vm.selectObj.sampleCompany
                                : "") +
                              " " +
                              _vm.$t("goodsSku.detail.Price"),
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      "$" + _vm._s(scope.row.slendierPrice)
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "quote",
                            label: _vm.$t("toolsProfit.Quote"),
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-input",
                                      {
                                        staticClass: "full-width",
                                        staticStyle: { width: "100px" },
                                        attrs: {
                                          controls: false,
                                          onkeyup:
                                            "this.value = this.value.replace(/[^\\d.-]/g,'');",
                                        },
                                        model: {
                                          value: scope.row.quote,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "quote", $$v)
                                          },
                                          expression: "scope.row.quote",
                                        },
                                      },
                                      [
                                        _c("template", { slot: "prepend" }, [
                                          _vm._v("$"),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
      _c("BjDialogList", {
        ref: "BjDialogListRef",
        attrs: {
          width: "80%",
          serial: false,
          "show-tags": false,
          config: _vm.BjDialogListConfig,
        },
        on: { confirm: _vm.confirm },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }